// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_2kmA8vTfqPX4IM2WbbZXW6","forceColor":"_397wnA3AAUmEqjuuAjcq4b","primaryColor":"_2EcuJRhie2s5C95fQgL06V","spaceLeft":"LsFmehVB7gPT2r8o7ZUyf"};